export default "<div [id]=\"id\" class=\"container-map\" [ngStyle]=\"{width: width, height: height}\"></div>\n";